import { Component, OnInit, Input } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { MatDialogConfig, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { ViewApprovalHistoryComponent } from '../view-approval-history/view-approval-history.component';

@Component({
  selector: 'app-timeline',
  templateUrl: './timeline.component.html',
  styleUrls: ['./timeline.component.scss'],
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({ transform: 'translateY(-100%)' }),
        animate('200ms ease-in', style({ transform: 'translateY(0%)' }))
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({ transform: 'translateY(-100%)' }))
      ])
    ])
  ]
})
export class TimelineComponent implements OnInit {

  data = [{
    cr_date: "2020-02-27T04:57:51.743",
    cr_user_id: "Praphul Bhat",
    notes: "<p>hey</p>",
    status: 1,
    t_id: 13,
  },
  {
    cr_date: "2020-02-27T04:57:51.743",
    cr_user_id: "Praphul Bhat",
    notes: "<p>hey</p>",
    status: 1,
    t_id: 13,
  },
  {
    cr_date: "2020-02-27T04:57:51.743",
    cr_user_id: "Praphul Bhat",
    notes: "<p>hey</p>",
    status: 1,
    t_id: 13,
  },
  {
    cr_date: "2020-02-27T04:57:51.743",
    cr_user_id: "Praphul Bhat",
    notes: "<p>hey</p>",
    status: 1,
    t_id: 13,
  },
  {
    cr_date: "2020-02-27T04:57:51.743",
    cr_user_id: "Praphul Bhat",
    notes: "<p>hey</p>",
    status: 1,
    t_id: 13,
  },
  {
    cr_date: "2020-02-27T04:57:51.743",
    cr_user_id: "Praphul Bhat",
    notes: "<p>hey</p>",
    status: 1,
    t_id: 13,
  },
  {
    cr_date: "2020-02-27T04:57:51.743",
    cr_user_id: "Praphul Bhat",
    notes: "<p>hey</p>",
    status: 1,
    t_id: 13,
  },
  {
    cr_date: "2020-02-27T04:57:51.743",
    cr_user_id: "Praphul Bhat",
    notes: "<p>hey</p>",
    status: 1,
    t_id: 13,
  },
  {
    cr_date: "2020-02-27T04:57:51.743",
    cr_user_id: "Praphul Bhat",
    notes: "<p>hey</p>",
    status: 1,
    t_id: 13,
  },
  {
    cr_date: "2020-02-27T04:57:51.743",
    cr_user_id: "Praphul Bhat",
    notes: "<p>hey</p>",
    status: 1,
    t_id: 13,
  },
  {
    cr_date: "2020-02-27T04:57:51.743",
    cr_user_id: "Praphul Bhat",
    notes: "<p>hey</p>",
    status: 1,
    t_id: 13,
  },
  {
    cr_date: "2020-02-27T04:57:51.743",
    cr_user_id: "Praphul Bhat",
    notes: "<p>hey</p>",
    status: 1,
    t_id: 13,
  },
  {
    cr_date: "2020-02-27T04:57:51.743",
    cr_user_id: "Praphul Bhat",
    notes: "<p>hey</p>",
    status: 1,
    t_id: 13,
  },
  {
    cr_date: "2020-02-27T04:57:51.743",
    cr_user_id: "Praphul Bhat",
    notes: "<p>hey</p>",
    status: 1,
    t_id: 13,
  }
  ]
  @Input() timeline;
  @Input() title;
  @Input() req_history;
  @Input() res_history;
  @Input() business_history;
  @Input() history;
  @Input() req_id;
  @Input() res_id;
  approval_flag = true;
  constructor(
    private dialogRef: MatDialogRef<ViewApprovalHistoryComponent>,
    private dialog: MatDialog,
  ) {

  }

  ngOnInit() {
    // this.timeline = this.data;
    // this.title = "sam"


    //
    //

  }


  viewApprovalHistory(approval_id, log_id) {
    this.approval_flag = false;
    const dialogConfig = new MatDialogConfig()
    dialogConfig.width = "35%";
    dialogConfig.height = "auto";
    dialogConfig.panelClass = "req_status";
    let ref = this.dialog.open(ViewApprovalHistoryComponent, dialogConfig);
    (ref.componentInstance).history = this.timeline;
    (ref.componentInstance).req_id = this.req_id;
    (ref.componentInstance).approval_id = approval_id;
    (ref.componentInstance).transaction_id = log_id;
    // ref.afterClosed().subscribe(res => {
    //   if (res) {
    //     // this.getStatusDetails();
    //     this.approval_flag = false;
    //   }

    // })
  }


}
